import { Black } from "src/styles/color";
import device from "src/styles/device";
import styled from "styled-components";

const Wrapper = styled.div`
  width: 100%;
  position: sticky;
  top: 0;
  background-color: #ffffff;
  /* border-bottom: 1px solid #d8d8dc; */
  z-index: 100;
`;

const Fixed = styled.div`
  width: 100%;
  padding: 24px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  height: 72px;
  border-bottom: 1px solid #d8d8dc;

  @media ${device.laptop} {
    height: 48px;
    padding: 12px 20px;
  }
`;

const WrapTitle = styled.div`
  width: max-content;
  display: flex;
  align-items: center;
  gap: 24px;
`;

const Title = styled.span`
  color: ${Black};
  font-size: 1.15rem;
  font-weight: 600;

  @media ${device.lcd} {
    font-size: 1rem;
  }
  @media ${device.laptop} {
    font-size: 0.875rem;
  }
`;

const SubTitle = styled.span`
  color: #bcbcc0;
  font-size: 1rem;
  font-weight: 600;

  span {
    font-size: 1rem;
    font-weight: 400;
  }
`;

const WrapMultiButton = styled.span`
  width: max-content;
  display: flex;
  align-items: center;
  gap: 24px;
`;

const Subheader = styled.div`
  width: 100%;
  position: relative;
  height: 34px;
  background-color: ${({ isAdmin }) =>
    isAdmin ? "#005FCC" : "rgb(191, 0, 19)"};
  font-size: 0.85rem;
  font-weight: 400;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;

  @media ${device.tabletL} {
    text-align: center;
    height: max-content;
    padding: 2px 18px;
    font-size: 0.75rem;
  }
`;

const Header = ({
  title = "",
  subTitle = "",
  label,
  children,
  isSubHeader = false,
  isAdmin = false,
  subHeader,
}) => {
  return (
    <Wrapper>
      <Fixed>
        <WrapTitle>
          <Title>{title}</Title>

          {subTitle && <SubTitle>{subTitle}</SubTitle>}

          {label && label}
        </WrapTitle>

        <WrapMultiButton>{children}</WrapMultiButton>
      </Fixed>

      {isSubHeader && <Subheader isAdmin={isAdmin}>{subHeader}</Subheader>}
    </Wrapper>
  );
};

export default Header;
